import { SearchspringCollectionProvider } from 'libs/searchspring/fetchers/collection'

import { useScrollCache } from 'libs/searchspring/hooks/useScrollCache'
import clsx from 'clsx'
import { useGridSelector } from 'libs/searchspring/components/collection/useGridSelector'
import { useIntersectionObserver } from '@/components/hooks/useIntersectionObserver'
import { CollectionToolbar } from 'libs/searchspring/components/collection/CollectionToolbar'
import { FloatingToolbarPortal } from 'libs/searchspring/components/collection/FloatingToolbar'
import { useEffect, useState } from 'preact/hooks'
import { FiltersProvider } from 'libs/searchspring/hooks/useFilters'
import { ResultItem } from 'libs/searchspring/components/ResultCardWrapper'
import { CustomFilter } from 'libs/searchspring/components/collection/filters/CustomFilter'
import { useFilterScroll } from 'libs/searchspring/hooks/useFilterScroll'
import { useScrollPositionKeeper } from 'libs/searchspring/hooks/useScrollPositionKeeper'
import { useInfiniteScrollResults } from 'libs/searchspring/hooks/useInfiniteScrollResults'
import { InfiniteScrollNext, InfiniteScrollPrevious } from 'libs/searchspring/components/collection/InfiniteScroll'
import { scrollHistoryManager } from 'helpers/scroll-history'

function CollectionGrid({ customFilter }) {
  history.scrollRestoration = 'manual'
  const [firstLoad, setFirstLoad] = useState(true)
  const { allResults, gridChange, isLoading, results } = useInfiniteScrollResults()
  const { setEntry } = useScrollPositionKeeper(gridChange)
  const { setScrollElement } = useFilterScroll()

  // Grid column count toggle
  const { GridSelector, gridTailwind, cssGridVariables, grid } = useGridSelector()

  // Collection Toolbar Visibility
  const { setNode, entry: toolbarRef } = useIntersectionObserver({
    rootMargin: '-100px',
    threshold: 0
  })
  const [toolbarVisible, setToolbarVisible] = useState(true)
  useEffect(() => {
    setToolbarVisible(!toolbarRef?.isIntersecting)
  }, [toolbarRef, toolbarRef?.isIntersecting])

  const totalResults = results?.pagination?.totalResults || 0

  useEffect(() => {
    if (!isLoading) setFirstLoad(false)
  }, [isLoading])

  useScrollCache([allResults, firstLoad])

  return (
    <div className="flex flex-col">
      <FiltersProvider >
          {customFilter && <CustomFilter filter={customFilter} />}
          <CollectionToolbar GridSelector={GridSelector} setRef={setNode} />
          <FloatingToolbarPortal GridSelector={GridSelector} visible={toolbarVisible} selector={'filter-portal'} />
      </FiltersProvider>
      {totalResults > 0 ? <div className={'px-3 md:px-6 py-2 md:py-4 text-neutral-secondary paragraph-md'}>{totalResults} Products</div> : null}
      <div
        style={cssGridVariables}
        data-grid-variant={grid.value}
        ref={(el) => { setScrollElement(el); setEntry(el) }}
        className={clsx('grid group/product-grid [grid-auto-flow:row_dense] border-t border-l border-neutral-medium', gridTailwind, (isLoading && firstLoad) && 'min-h-[90vh]')}
      >
        <InfiniteScrollPrevious />
          {
            allResults?.map((item, index) => {
              return <ResultItem item={item} key={item.handle} className="border-b border-r wk-wishlist-button-target border-neutral-medium" dataIndex={index} />
            })
          }
      </div>
      {allResults.length > 0 && !firstLoad && (
        <div className="flex justify-center px-4 py-6">
          <InfiniteScrollNext />
        </div>
      )}
    </div>
  )
}

export function WrappedCollectionGrid({ customFilter, perPage }) {
  const resultsPerPage = perPage || window.settings?.per_page
  scrollHistoryManager.updateHistoryState()
  return (
    <SearchspringCollectionProvider handle={window.collection?.handle} resultsPerPage={resultsPerPage}>
      <CollectionGrid customFilter={customFilter} />
    </SearchspringCollectionProvider>
  )
}
